import { useEffect, useRef, useState } from "react";
import visualBeatRegistry from "../audio/visualBeatRegistry";
import beatVisualController from "../audio/BeatVisualController";

// Declarative beat-visual hook. Registers a listener for a beat event and returns a `pulse`
// counter that increments on each fired beat (only when beat visuals are active + allowed).
// Components use `pulse` to key a CSS animation. Never blocks input or gameplay.
export function useBeatVisual({ event, effect, intensity = "subtle", enabled = true }) {
  const [pulse, setPulse] = useState(0);
  const idRef = useRef(null);

  useEffect(() => {
    if (!event) return undefined;
    const id = visualBeatRegistry.register({
      event, effect, intensity, enabled,
      cb: () => setPulse((p) => (p + 1) % 100000),
    });
    idRef.current = id;
    return () => visualBeatRegistry.unregister(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, effect]);

  useEffect(() => {
    if (idRef.current) visualBeatRegistry.update(idRef.current, { enabled, intensity });
  }, [enabled, intensity]);

  return { pulse, active: beatVisualController.active && !beatVisualController.reducedMotion };
}

export default useBeatVisual;
